import COLOR from 'constants/color';
import { IconProps } from 'interfaces';
import { isDarkMode } from 'utils/validators';

const PaletteIcon = ({
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE,
  className = '~w-4/5 h-auto'
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.25 6C1.25 3.37665 3.37665 1.25 6 1.25C8.62335 1.25 10.75 3.37665 10.75 6V6.43202L12.7833 4.39868C14.6383 2.54369 17.6459 2.54369 19.5008 4.39868C21.3558 6.25367 21.3558 9.26121 19.5008 11.1162L17.367 13.25H18C20.6234 13.25 22.75 15.3766 22.75 18C22.75 20.6234 20.6234 22.75 18 22.75H6C3.37665 22.75 1.25 20.6234 1.25 18V6ZM9.46412 21.25H18C19.7949 21.25 21.25 19.7949 21.25 18C21.25 16.2051 19.7949 14.75 18 14.75H15.867L9.8889 20.7281C9.7596 20.9121 9.61758 21.0865 9.46412 21.25ZM10.75 17.7457L18.4402 10.0555C19.7094 8.78633 19.7094 6.72855 18.4402 5.45934C17.171 4.19014 15.1132 4.19014 13.844 5.45934L10.75 8.55334V17.7457ZM6 2.75C4.20507 2.75 2.75 4.20507 2.75 6V18C2.75 19.7949 4.20507 21.25 6 21.25C7.79493 21.25 9.25 19.7949 9.25 18V6C9.25 4.20507 7.79493 2.75 6 2.75ZM6 17.75C5.86193 17.75 5.75 17.8619 5.75 18C5.75 18.1381 5.86193 18.25 6 18.25C6.13807 18.25 6.25 18.1381 6.25 18C6.25 17.8619 6.13807 17.75 6 17.75ZM4.25 18C4.25 17.0335 5.0335 16.25 6 16.25C6.9665 16.25 7.75 17.0335 7.75 18C7.75 18.9665 6.9665 19.75 6 19.75C5.0335 19.75 4.25 18.9665 4.25 18Z'
        fill={fillColor}></path>
    </svg>
  );
};

export default PaletteIcon;
